export const UPDATE_CART = 'CART/UPDATE'
export const ADD_TO_CART = "CART/ADD/ITEM";
export const TOGGLE_CART = "CART/TOGGLE/ITEM";
export const UPDATE_CART_ITEM = 'CART/UPDATE/ITEM';
export const REMOVE_FROM_CART = 'CART/REMOVE/ITEM';

export const SET_FILTER = "SET_FILTER";

export const RELOAD_PAGE = 'PAGE/RELOAD';

export const UPDATE_CATEGORIES = 'CATEGORY/LIST';

export const UPDATE_PRODUCT_LIST = 'PRODUCTS/LIST';

export const UPDATE_CURRENT_PRODUCT = 'PRODUCTS/UPDATE';
